// var examQuestion = require('./question');
// var choices = require('./choices');
// var choicesRight = require('./quizChoicesRight');

var dermPathFrame = function() {
    var exam = $.parseHTML(
        '<div class="dermpath-frame row">' +
            '<div class="title-row row">' +
                '<div class="col-lg-12 col-md-12">' +
                '<h2 class="exam-title">What\'s the Diagnosis?</h2>' +
                '</div>' +
            '</div>' +
            '<div class="row image-row">' +
                '<div class="image-column col-lg-12 col-md-12"><div class="image-frame"></div>' +
                '</div>' +
            '</div>' +
            '<div class="row diagnosis-row">' +
                '<div class="col-lg-2 col-md-2"><button id="show-answer" class="btn btn-default">Show Answer</button></div>' +
                '<div class="diagnosis col-lg-8 col-md-8 no-show"><span></span></div>' +
                '<div class="count col-lg-2 col-md-2"></div>' +
            '</div>' +
            '<div class="row nav-row">' +
                '<div class="col-lg-2 col-md-2 question-nav">' +
                    '<div class="btn-group">' +
                        '<button class="btn btn-default previous" disabled="disabled"><span class="glyphicon glyphicon-chevron-left"></span></button>' +
                        '<button class="btn btn-default next"><span class="glyphicon glyphicon-chevron-right"></span></button>' +
                    '</div>' +
                '</div>' +
                '<div class="col-lg-6 col-md-6 progress-nav"><div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div></div>' +
                '<div class="col-lg-4 col-md-4 save-nav">' +
                    '<div class="btn-group">' +
                        '<button class="btn btn-default" type="button" id="report">Report</button>' +
                        '<button class="btn btn-default" type="button" id="finish">Finish</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>');

    // $(exam).find('.choices-row .choices .list-group').append(choices([]))
    // $(exam).find('.choices-row').append(choicesRight());
    return exam;
}

module.exports = dermPathFrame;


//////////////////
// WEBPACK FOOTER
// ./src/slidestudy_frame.js
// module id = 320
// module chunks = 0